import { useEffect, useState } from 'react';
import { C } from '../../constants/colors.js';
import { F, N } from '../../constants/fonts.js';
import { supaGetSession } from '../../lib/supabase.js';

export function PinGate({pin:correctPin,onUnlock,onSetPin,onCancel}) {
  const [p, setP] = useState('');
  const [wrong, setWrong] = useState(false);
  const [newPin, setNewPin] = useState('');
  const [confirm, setConfirm] = useState('');
  const [step, setStep] = useState(correctPin ? 'enter' : 'set');
  const [mismatch, setMismatch] = useState(false);
  const [fpState, setFpState] = useState(null);

  useEffect(() => {
    setStep(correctPin ? 'enter' : 'set');
    setP('');
    setNewPin('');
    setConfirm('');
    setWrong(false);
    setMismatch(false);
    setFpState(null);
  }, [correctPin]);

  const isSet = step === 'set' || step === 'confirm';
  const title = step === 'set' ? 'Set a Parent PIN' : step === 'confirm' ? 'Confirm PIN' : 'Enter Parent PIN';
  const dots = step === 'set' ? newPin : step === 'confirm' ? confirm : p;
  const err = wrong || mismatch;

  const handleSetDigit = (digit) => {
    if (step === 'set') {
      const nextPin = newPin + digit;
      setNewPin(nextPin);
      if (nextPin.length === 4) setStep('confirm');
      return;
    }
    const nextConfirm = confirm + digit;
    setConfirm(nextConfirm);
    if (nextConfirm.length === 4) {
      if (nextConfirm === newPin) {
        onSetPin(nextConfirm);
        onUnlock();
      } else {
        setMismatch(true);
        setConfirm('');
        setStep('set');
        setNewPin('');
        setTimeout(() => setMismatch(false), 600);
      }
    }
  };

  const handleEnterDigit = (digit) => {
    const nextPin = p + digit;
    setP(nextPin);
    if (nextPin.length === 4) {
      if (nextPin === correctPin) {
        onUnlock();
      } else {
        setWrong(true);
        setP('');
        setTimeout(() => setWrong(false), 600);
      }
    }
  };

  const handleDigit = (digit) => {
    if (isSet) handleSetDigit(digit);
    else handleEnterDigit(digit);
  };

  const handleBackspace = () => {
    if (step === 'confirm') setConfirm((value) => value.slice(0, -1));
    else if (step === 'set') setNewPin((value) => value.slice(0, -1));
    else setP((value) => value.slice(0, -1));
  };

  const handleForgotPin = async () => {
    setFpState('checking');
    try {
      const session = await supaGetSession();
      setFpState(session?.user ? 'confirmed' : 'no_auth');
    } catch {
      setFpState('no_auth');
    }
  };

  const doReset = () => {
    onSetPin(null);
    setStep('set');
    setP('');
    setNewPin('');
    setConfirm('');
    setFpState(null);
  };

  return (
    <div style={{ textAlign: 'center', padding: '40px 24px' }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
      <h3 style={{ fontFamily: F, fontSize: 22, color: C.text, margin: '0 0 20px' }}>{title}</h3>
      {mismatch && <p style={{ fontFamily: N, fontSize: 13, color: C.danger, margin: '-12px 0 12px' }}>PINs didn&apos;t match. Try again.</p>}
      {fpState === 'no_auth' && <div style={{ background: C.dangerLight, borderRadius: 12, padding: '10px 14px', marginBottom: 12, fontFamily: N, fontSize: 13, color: C.danger }}>Sign in with your Google or email account to reset your PIN.<button onClick={() => setFpState(null)} style={{ display: 'block', margin: '8px auto 0', background: 'transparent', border: 'none', fontFamily: N, fontSize: 12, color: C.textLight, cursor: 'pointer', textDecoration: 'underline' }}>Cancel</button></div>}
      {fpState === 'confirmed' && <div style={{ background: C.successLight, borderRadius: 12, padding: '12px 14px', marginBottom: 12, fontFamily: N, fontSize: 13, color: C.text, lineHeight: 1.4 }}>Account verified. PIN will be reset. You&apos;ll set a new one now.<div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 10 }}><button onClick={doReset} style={{ padding: '8px 18px', borderRadius: 12, border: 'none', background: C.success, color: '#fff', fontFamily: F, fontSize: 14, cursor: 'pointer' }}>Reset PIN</button><button onClick={() => setFpState(null)} style={{ padding: '8px 14px', borderRadius: 12, border: '2px solid #E5E7EB', background: C.bg, fontFamily: F, fontSize: 14, color: C.textMid, cursor: 'pointer' }}>Cancel</button></div></div>}
      <div style={{ display: 'flex', gap: 14, justifyContent: 'center', marginBottom: 28 }}>
        {[0, 1, 2, 3].map((i) => <div key={i} style={{ width: 20, height: 20, borderRadius: 10, background: dots.length > i ? C.primary : err ? C.danger : '#E5E7EB' }} />)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, maxWidth: 220, margin: '0 auto' }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, '⌫'].map((digit, i) => (
          <button key={i} onClick={() => digit === '⌫' ? handleBackspace() : digit !== null && handleDigit(String(digit))} disabled={digit === null} style={{ height: 52, borderRadius: 14, border: '2px solid #F0F0F5', background: digit === null ? 'transparent' : C.bg, color: C.text, fontFamily: F, fontSize: digit === '⌫' ? 16 : 22, cursor: digit === null ? 'default' : 'pointer' }}>
            {digit}
          </button>
        ))}
      </div>
      {step === 'enter' && !fpState && <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}><button onClick={handleForgotPin} style={{ background: 'transparent', border: 'none', fontFamily: N, fontSize: 14, color: C.secondary, cursor: 'pointer', textDecoration: 'underline' }}>Forgot PIN?</button>{onCancel && <button onClick={onCancel} style={{ background: 'transparent', border: 'none', fontFamily: N, fontSize: 13, color: C.textLight, cursor: 'pointer' }}>Cancel</button>}</div>}
      {step === 'enter' && fpState === 'checking' && <div style={{ marginTop: 16, fontFamily: N, fontSize: 13, color: C.textLight }}>Checking your account...</div>}
      {isSet && onCancel && <button onClick={onCancel} style={{ marginTop: 18, background: 'transparent', border: 'none', fontFamily: N, fontSize: 13, color: C.textLight, cursor: 'pointer' }}>Cancel</button>}
    </div>
  );
}
